import { Component, Input } from '@angular/core';
import { OrganizationConfig } from '../../../../../../../../models/organization-config';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AccountService } from '../../../../../../../../services/account/account.service';
import { GiftPrintBannerImageOption } from '../../../../../../../../models/gift';


@Component({
  selector: 'app-gift-pdf-preview-modal',
  templateUrl: 'gift-pdf-preview-modal.component.html',
  styleUrls: ['gift-pdf-preview-modal.component.css']
})
export class GiftPdfPreviewModalComponent {
  @Input() orgConfig: OrganizationConfig;
  @Input() bannerImageOption: GiftPrintBannerImageOption;

  constructor(
    public accountService: AccountService,
    public activeModal: NgbActiveModal,
  ) {}

  public getLogoImage() {
    if (this.orgConfig.gift_print_logo_image) {
      return this.orgConfig.gift_print_logo_image;
    }
    if (this.orgConfig.logo_image) {
      return this.orgConfig.logo_image;
    }
    return '';
  }
}
